/* PerfeX · Avísame cuando esté disponible.
   El formulario se envía de forma nativa (así Shopify puede añadir su verificación contra bots).
   Al volver, Shopify añade el ancla del formulario y se muestra su confirmación. */
if (!customElements.get('perfex-aviso')) {
  customElements.define('perfex-aviso', class extends HTMLElement {
    connectedCallback() {
      var form = this.querySelector('form');
      if (!form || this.bound) return;
      this.bound = true;
      var details = this.querySelector('details');
      if (form.id && window.location.hash === '#' + form.id) {
        if (details) details.open = true;
        var ok = form.querySelector('.px-aviso__ok');
        if (ok && window.getComputedStyle(ok).display !== 'none') ok.focus({ preventScroll: true });
      }
      var button = form.querySelector('[type="submit"]');
      form.addEventListener('submit', function () {
        form.setAttribute('aria-busy', 'true');
        if (button) button.classList.add('is-sending');
      });
      window.addEventListener('pageshow', function (event) {
        if (!event.persisted) return;
        form.removeAttribute('aria-busy');
        if (button) button.classList.remove('is-sending');
      });
    }
  });
}
